export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8769.942d7c01.jpg";